import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable, ReplaySubject } from 'rxjs'
import { tap } from 'rxjs/operators'
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AppConfig } from '@wm-front/shared/interfaces'

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private http = inject(HttpClient)

  /** The subject containing the app config for a given project */
  private appConfigSubject: ReplaySubject<AppConfig> = new ReplaySubject()

  /** The app config as Observable */
  public get appConfig$(): Observable<AppConfig> {
    return this.appConfigSubject.asObservable()
  }

  /** Returns the config for a given app and env and maybe later language
   * @param { string } appName the name of the app of which we load the config ex : wm-front or wm-admin
   * @param { boolean } prod whether or not the app is in prod mode or not
   * @return { Promise<AppConfig> } the config of the app
   */
  public loadAppConfig(appName: string, prod: boolean): Observable<AppConfig> {
    /** Set up the path for prod or dev and for any project */
    const path = prod ? `${appName}-prod` : `${appName}-dev`

    return this.http.get<AppConfig>(`assets/config/${path}.json`).pipe(
      tap((data: AppConfig) => {
        /** Exposed To be used for later in the app */
        this.appConfigSubject.next(data)
      })
    )
  }
}
